import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InputErrorComponent } from './input-error.component';

@NgModule({
  imports: [CommonModule],
  declarations: [InputErrorComponent],
  exports: [InputErrorComponent]
})
export class InputErrorModule {}
